<template>
    <div id="andonState" style="width: 100%; height: 75%"></div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  props: {
    shopInfo: {
      type: Object,
      default: ''
    }
  },
  data () {
    return {
      signinBeg: {
        fcCode: '',  //工厂
        shopCode: '',   //车间
        sectionCode: '',   //工段
        lineCode: ''
      },
      andonStateInfo: [],
    }
  },
  watch: {
    shopInfo: {
      handler (val) {
        this.signinBeg.fcCode = val.fcCode
        this.signinBeg.shopCode = val.shopCode
        this.signinBeg.sectionCode = val.sectionCode
        this.signinBeg.lineCode = val.lineCode
        this.lineState()
      },
      deep: true
    }
  },
  mounted () {
      if (window.sessionStorage.getItem('userInfo')) {
          let userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'))
          if (userInfo.factoryId == 0) {
              this.lineState()
          }
      }
  },
  methods: {
    //安灯状态
    lineState () {
      let options = {
        method: 'GET',
        url: this.$api.andonStateecharts,
        params: this.signinBeg
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          this.andonStateInfo = response.data.andonStatusVO
          this.andonStateechar()
        } else {
          this.$message.error('请求失败！')
        }
      })
    },
    //设备状态柱形图
    andonStateechar () {
      var self = this
      var chartDom = document.getElementById('andonState')
      var myChart = echarts.init(chartDom)
      window.addEventListener('resize', () => {
        myChart.resize()
      })
      var option
      //整条柱形的点击事件
      /*myChart.on('click', function (params) {
        let array = {}
        let andonStatus = ''
        if (self.signinBeg.fcCode != undefined && self.signinBeg.fcCode != '') {
          array['fcCode'] = self.signinBeg.fcCode
        }
        if (self.signinBeg.shopCode != undefined && self.signinBeg.shopCode != '') {
          array['shopCode'] = self.signinBeg.shopCode
        }
        if (self.signinBeg.sectionCode != undefined && self.signinBeg.sectionCode != '') {
          array['sectionCode'] = self.signinBeg.sectionCode
        }
        if (self.signinBeg.lineCode != undefined && self.signinBeg.lineCode != '') {
          array['lineCode'] = self.signinBeg.lineCode
        }
        if (params.name == '接单') {
          andonStatus = 'create'
        }
        if (params.name == '维修') {
          andonStatus = 'wait_complete'
        }
        if (params.name == '验收') {
          andonStatus = 'wait_accept'
        }
        if (andonStatus != '') {
          array['andonStatus'] = andonStatus
        }
        self.$router.push({
          name: 'acoustoSpectaculars',
          params: {
            andonState: array
          }
        })
      })*/
      var xData = ['接单', '维修', '验收', '结束']
      var yData = [this.andonStateInfo.andonCreate, this.andonStateInfo.andonWaitComp, this.andonStateInfo.andonWaitAcce, this.andonStateInfo.andonComp]
      option = {
        'grid': {
          'top': '25%',
          'left': '-5%',
          'bottom': '5%',
          'right': '5%',
          'containLabel': true
        },
        tooltip: {
          show: true
          //   trigger: 'axis',
          //   axisPointer: {
          //     type: 'shadow'
          //   },
          //   textStyle: {
          //     color: '#999',
          //     align: 'left'
          //   },
          //   position: ['30%', '30%'],
          //   extraCssText:
          //     'box-shadow:0px 0px 8px 0px rgba(176,176,176,1)',
          //   backgroundColor: '#fff',
          //   formatter: function (params) {
          //     console.log(params)
          //     //去除重复数据
          //     for (var i = 0;i < params.length;i++) {
          //       for (var j = params.length - 1;j > i;j--) {
          //         if (
          //           params[j].seriesName == params[i].seriesName
          //         ) {
          //           params.splice(j, 1)
          //           break
          //         }
          //       }
          //     }
          //     var res = ''
          //     console.log(params)
          //     var data = '<p>' + params[0].name + '</p >'
          //     res += '<p>' + params[0].value + '</p >'
          //     return data + res
          //   }
        },
        animation: false,
        'xAxis': [{
          'type': 'category',
          'data': xData,
          'axisTick': {
            'alignWithLabel': true
          },
          'nameTextStyle': {
            'color': '#82b0ec'
          },
          'axisLine': {
            show: false,
            'lineStyle': {
              'color': '#82b0ec'
            }
          },
          'axisLabel': {
            interval: 0,
            'textStyle': {
              'color': '#fff'
            },
            margin: 30
          }
        }],
        'yAxis': [{
          show: false,
          'type': 'value',
          'axisLabel': {
            interval: 0,
            'textStyle': {
              'color': '#fff'
            }
          },
          'splitLine': {
            'lineStyle': {
              'color': '#0c2c5a'
            }
          },
          'axisLine': {
            'show': false
          }
        }],
        'series': [{
          'name': '',
          type: 'pictorialBar',
          symbolSize: [20, 10],
          symbolOffset: [0, -6],
          symbolPosition: 'end',
          z: 12,
          // "barWidth": "0",
          'label': {
            'normal': {
              'show': true,
              'position': 'top',
              // "formatter": "{c}%"
              fontSize: 15,
              fontWeight: 'bold',
              color: '#5bfcf4'
            }
          },
          color: '#5bfcf4',
          data: yData
        },
        {
          name: '',
          type: 'pictorialBar',
          symbolSize: [20, 10],
          symbolOffset: [0, 7],
          // "barWidth": "20",
          z: 12,
          'color': '#5bfcf4',
          'data': yData
        },
        // {
        //   name: '',
        //   type: 'pictorialBar',
        //   symbolSize: [30, 15],
        //   symbolOffset: [0, 15],
        //   z: 10,
        //   itemStyle: {
        //     normal: {
        //       color: 'transparent',
        //       borderColor: '#ff2323',
        //       borderType: 'solid',
        //       borderWidth: 10
        //     }
        //   },
        //   data: yData
        // },
        // {
        //   name: '',
        //   type: 'pictorialBar',
        //   symbolSize: [40, 20],
        //   symbolOffset: [0, 18],
        //   z: 10,
        //   itemStyle: {
        //     normal: {
        //       color: 'transparent',
        //       borderColor: '#ff2323',
        //       borderType: 'solid',
        //       borderWidth: 8
        //     }
        //   },
        //   data: yData
        // },
        {
          type: 'bar',
          //silent: true,
          'barWidth': '20',
          barGap: '10%', // Make series be overlap
          barCateGoryGap: '10%',
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 0.7, [{
                offset: 0,
                color: '#38B2E6'
              },
              {
                offset: 1,
                color: '#0B3147'
              }
              ]),
              opacity: .8
            }
          },
          data: yData
        }
        ]
      }
      option && myChart.setOption(option)
    }
  }
}
</script>

<style>
</style>
